module.exports = __webpack_public_path__ + "static/media/background_640px_WEBP.aa97c1b1.webp";